import { useLayoutEffect } from 'react';

import { getZipCode, isZipCode } from '@/lib/tagging/utils';
import useAppointmentStore from '@/store/AppointmentStore';

const ZIP_COOKIE_POLL_MS = 200;

const useZipRouterSync = () => {
  const setPreSelectedZipCode = useAppointmentStore(
    (state) => state.setPreSelectedZipCode,
  );

  useLayoutEffect(() => {
    const applyFromCookie = () => {
      const selectedZip =
        useAppointmentStore.getState().preSelectedZipCode?.trim() ?? '';
      if (selectedZip) {
        return true;
      }

      const zipCode = getZipCode().trim();
      if (!isZipCode(zipCode)) {
        return false;
      }

      setPreSelectedZipCode(zipCode);
      return true;
    };

    if (applyFromCookie()) {
      return;
    }

    const intervalId = window.setInterval(() => {
      if (applyFromCookie()) {
        window.clearInterval(intervalId);
      }
    }, ZIP_COOKIE_POLL_MS);

    return () => {
      window.clearInterval(intervalId);
    };
  }, [setPreSelectedZipCode]);
};

export default useZipRouterSync;
